
/* MODULE IMPORTS */
import React, { Component } from 'react';
import sendLogError from "../../sendLogError";

/* CSS IMPORT */
import './Sidebar.css';


class MobileSidebar extends Component {
    static displayName = MobileSidebar.name;

    constructor(props) {
        super(props);
        this.state = { 
            manager: [], 
            loading: true 
        };
    }

    componentDidMount() {
        this.populateManagerData();
    }

    render() {
        return (
            <div className="minimized-sidebar"></div>
        );
    }

    async populateManagerData() {
        try {
            const response = await fetch("/sidebar/get");

            if (!response.ok) {
                throw new Error(`Erro HTTP: ${response.status}`);
            }

            const data = await response.json();

            this.setState({
                manager: data,
                loading: false
            });

        } catch (error) {
            console.error("Error fetching manager data:", error);

            this.setState({
                manager: null,
                loading: false
            });

            sendLogError(error.message, "populateManagerData");
        }
    }
}
export default MobileSidebar;